type AdTask = () => Promise<void> | void;

declare global {
  interface Window {
    __tvAdQueue?: Promise<void>;
  }
}

/**
 * Many ad networks rely on a global `atOptions` object.
 * If multiple placements inject scripts at the same time, `atOptions` can be overwritten
 * before the remote script executes, resulting in blank ads.
 *
 * This queue ensures ad scripts are injected sequentially.
 */
export function enqueueAdLoad(task: AdTask): Promise<void> {
  const prev = window.__tvAdQueue ?? Promise.resolve();
  const next = prev
    .catch(() => {
      // Keep queue alive even if a previous task failed.
    })
    .then(() => task());

  window.__tvAdQueue = next.then(() => undefined);
  return window.__tvAdQueue;
}
